import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';
import { coverImage } from '../../routes/_app.$username/profile-card/profile-card.css';

export const modalContent = style([
  responsiveStyle({
    tablet: {
      minWidth: '405px',
      maxWidth: '700px',
      width: 'max-content',
    },
  }),
]);

export const updateImageForm = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s24,
    alignItems: 'center',

    selectors: {
      '&[data-drag-over]': {
        outline: `2px dashed ${themeVars.controls.border.active}`,
        outlineOffset: '4px',
      },
    },
  },
]);

export const imageContainer = style([
  {
    width: '100%',
    margin: `${space.s16}px 0`,
  },
]);

export const avatarBox = style([
  {
    display: 'flex',
    margin: '0 auto',
    height: '120px',
    width: '120px',
  },
]);

export const formInfo = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s8,
    alignItems: 'center',
  },
]);

export const formMainText = style([typography.titleLg]);

export const formSubText = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.tertiary,
  },
]);

export const updateImageBackgroundImg = style([
  coverImage,
  {
    borderRadius: borderRadius.r16,
  },
]);
